import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCuttingPlanStore } from '../../stores/cuttingPlanStore';

const SubstitutionTable = () => {
    const { t } = useTranslation();

    const allPatterns = useCuttingPlanStore(state => state.allPatterns);
    const rebarInformation = useCuttingPlanStore(state => state.rebarInformation);
    const showedPatterns = allPatterns.filter(pattern => pattern.show);
    const patternsWithSubstitutes = showedPatterns.filter(pattern => "substitutions" in pattern);
    const subtitutions = patternsWithSubstitutes.map((pattern, i) => {
        const substitutes = pattern.substitutions.map((substitution, j) => {
            return {
                patternNo: pattern.patternNo,
                diameter: pattern.diameter,
                subs_by: substitution.subs_by,
                count: substitution.number,
                actual: substitution.actual
            }
        });
        return substitutes;
    }).flat();

    return (
        <div className='table-responsive'>
            {subtitutions.length === 0 ? (
                <div className="alert alert-secondary text-center" role="alert">
                    {t("Yerine kullanım bulunmamaktadır.")}
                </div>
            ) :
                <table className="table table-sm border table-hover text-center">
                    <thead>
                        <tr>
                            <th scope="col">{t("Kesim No.")}</th>
                            <th scope="col">{t("Asıl Donatı Kodu")}</th>
                            <th scope="col">{t("Adet")}</th>
                            <th scope="col">{t("Çap")}</th>
                            <th scope="col">{t("Yerine Kullanılan")} (cm)</th>
                            <th scope="col">{t("Kat")}</th>
                            <th scope="col">{t("Y. Elemanı")}</th>
                            <th scope="col">{t("Eleman İsmi")}</th>
                            <th scope="col">{t("Açıklama")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subtitutions
                            .sort((a, b) => a.patternNo - b.patternNo)
                            .map((sub, i) => (
                                <tr key={i}>
                                    <td>{sub.patternNo}</td>
                                    <td>{sub.actual}</td>
                                    <td>{sub.count}</td>
                                    <td>{sub.diameter}</td>
                                    <td>{sub.subs_by}</td>
                                    <td>{rebarInformation[sub.actual]["kat"]}</td>
                                    <td>{rebarInformation[sub.actual]["yapiElemani"]}</td>
                                    <td>{rebarInformation[sub.actual]["yapiElemaniKodu"]}</td>
                                    <td>{rebarInformation[sub.actual]["aciklama"]}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            }
        </div>
    );
}

export default SubstitutionTable;